export enum AcceptFileEnum {
    IMAGE = '.png,.jpg,.jpeg',
    PDF = '.pdf',
    DOCX = '.docx',
    DOCUMENT = '.pdf,.docx',
    ALL = '.pdf,.png,.jpeg,.csv,.jpg,.eml,.msg,.docx',
}
